/**
 * 判断微信浏览器
 * @method isWeiXin
 */
export const isWeiXin = () => {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}

export const isAliPay = () => {
    // 判断是支付宝app的浏览器
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.match(/Alipay/i) == 'alipay') {
        return true
    } else {
        return false
    }
}


export const getQueryBbj = (url) => {
    const urlData = url.split('?')
    if (!urlData[1]) return {}
    const urlText = urlData[2] ? `${urlData[1]}&${urlData[2]}` : urlData[1]
    const queryArr = urlText.split('&')
    const queryObj = {}
    for (var i in queryArr) {
        var t = queryArr[i].split('=')
        queryObj[t[0]] = t[1]
    }
    return queryObj
}

export const judgeDate = (date1) => {
    return new Date(date1).getTime() - new Date().getTime() > 0
}
